import {Component, OnInit, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {FooterNavbarService} from 'services/connectors/footer-navbar.service';

@Component({
  selector: 'tpc-events-travel-default',
  templateUrl: './events-travel-default.component.html',
  styleUrls: ['./events-travel-default.component.css']
})
export class EventsTravelDefaultComponent implements OnInit, OnDestroy {

    private nextSub: Subscription;
    public travelType = 'length';

    constructor(private footerService: FooterNavbarService,
                private router: Router
    ) {
        this.nextSub = footerService.next$.subscribe(() => this.next());
    }

    ngOnInit() {
    }

    next() {
        this.router.navigate(['/events/travel/' + this.travelType]);
    }

    ngOnDestroy () {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/events-calculator/events-travel/events-travel-default/events-travel-default.component.ts